/**
 * Sets the zoom level of the Google Map instance.
 *
 * @param {object} options - The options for setting the zoom level.
 * @param {object} options.map - The Google Map instance to set the zoom level for.
 * @param {number} options.zoom - The zoom level to set.
 */
export const setZoom = ({ map, zoom }) => {
    map.setZoom(zoom);
};
